import axios from 'axios';
import { config } from '../apiConfig';

const ChangePassword = async (parameters) => {
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
        let response = await axios.post(`${config.url}/api/mvc/AgencyProfile/ChangePassword`, parameters, {
            headers: { "Authorization": `Bearer ${AccessToken}` }
        }).catch((error) => {
            return error.response;
        });
        return response;
    } else {
        window.location.href = 'https://iranhotelonline.com';

    }
}

export default ChangePassword;